<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :nudge-right="0"
    :nudge-top="0"
    offset-x
    right
    min-width="180"
    content-class="away-options-menu"
    transition="slide-x-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        :style="{
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          width: '100%',
          cursor: 'pointer',
        }"
      ></div>
    </template>
    <v-list class="away-options-list rounded-lg elevation-2 mt-0">
      <v-list-item
        v-for="(option, index) in pauseOptions"
        :key="index"
        :disabled="disabled"
        dense
        class="away-option-item py-2"
        @click="selectOption(option)"
      >
        <v-list-item-content>
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon size="18" color="primary" class="mr-2">
                mdi-clock-outline
              </v-icon>
              <span class="subtitle-2">{{ option.name }}</span>
            </div>
            <v-chip x-small outlined color="primary" class="time-chip">
              {{ formatDuration(option.duration) }}
            </v-chip>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="pauseOptions.length === 0" dense>
        <v-list-item-content class="text-center">
          <v-list-item-title class="caption grey--text">
            Nenhuma pausa disponível
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "MenuPauses",

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    pauseOptions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    showMenu: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    formatDuration(duration) {
      if (duration === 1) return `${duration}min`;
      return `${duration}mins`;
    },

    selectOption(option) {
      this.showMenu = false;
      this.$emit("select-option", option);
    },
  },
};
</script>

<style lang="scss" scoped>
.away-options-menu {
  margin-top: 0 !important;
  position: absolute;
  z-index: 100;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  min-width: 240px !important;
}

.away-options-list {
  background-color: #ffffff !important;
  border-radius: 4px !important;
  margin: 0;
  padding: 4px 0;
  max-height: 300px;
  overflow-y: auto;
}

.away-option-item {
  transition: all 0.2s ease;
  border-radius: 4px;
  padding: 0 12px;
  margin: 2px 4px;
  overflow: hidden;

  &:hover {
    background-color: rgba(#e35336, 0.08) !important;
  }

  .subtitle-2 {
    font-size: 0.875rem;
    font-weight: 500;
  }

  .time-chip {
    height: 20px !important;
    min-width: 40px;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 500;
  }
}

/* Estilização da barra de rolagem */
.away-options-list::-webkit-scrollbar {
  width: 6px;
}

.away-options-list::-webkit-scrollbar-track {
  background: transparent;
}

.away-options-list::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 2px;
  border: 5px solid #e35336;
}

.away-options-list::-webkit-scrollbar-thumb:hover {
  background: #e35336;
}
</style>
